import React from 'react';
import PropTypes from 'prop-types';
import './BookCard.scss';

const staticTexts = {
  planAlt: 'plan',
  tickAlt: 'tick',
  whatsIncluded: 'What\'s Included',
  select: 'Select',
};

function BookCard({
  title,
  visitType,
  originalPrice,
  amountToPay,
  bullets,
  tickIcon,
  imageIcon,
  onCardClick,
  isSelected,
}) {
  return (
    <div onClick={onCardClick} className={`bookCard${isSelected ? ' bookCard--selected' : ''}`}>
      <div className="bookCardTopRow">
        <div className="bookCardTextContent">
          <h3 className="bookCardTitle">{title}</h3>
          <p className="bookCardSubTitle">{visitType}</p>
          <div className="bookCardPriceRow">
            <span className="bookCardPrice">₹{amountToPay}</span>
            <span className="bookCardOriginalPrice">₹{originalPrice}</span>
          </div>
        </div>

        <div className="bookCardImageWrapper">
          <img
            src={imageIcon}
            alt={staticTexts.planAlt}
            width="80"
            height="80"
            className="bookCardImage"
          />
          <button
            className={`bookCardBookBtn${isSelected ? ' bookCardBookBtn--selected' : ''}`}
            onClick={(e) => { e.stopPropagation(); onCardClick && onCardClick(); }}
          >
            {staticTexts.select}
          </button>
        </div>
      </div>

      <div className="bookCardDivider" />

      <div className="bookCardIncludedRow">
        <span className="bookCardIncludedTitle">{staticTexts.whatsIncluded}</span>
      </div>

      <ul className="bookCardBulletList">
        {bullets.length > 0 &&
          bullets.map((bullet, index) => (
            <li key={index} className="bookCardBulletItem">
              <img
                src={tickIcon}
                alt={staticTexts.tickAlt}
                width="16"
                height="16"
                className="bookCardIcon"
              />
              <span>{bullet}</span>
            </li>
          ))}
      </ul>
    </div>
  );
}

BookCard.propTypes = {
  title: PropTypes.string,
  visitType: PropTypes.string,
  originalPrice: PropTypes.number,
  amountToPay: PropTypes.number,
  bullets: PropTypes.arrayOf(PropTypes.string),
  tickIcon: PropTypes.string,
  imageIcon: PropTypes.string,
  onCardClick: PropTypes.func,
  isSelected: PropTypes.bool,
};

BookCard.defaultProps = {
  title: '',
  visitType: '',
  originalPrice: 0,
  amountToPay: 0,
  bullets: [],
  tickIcon: '',
  imageIcon: '',
  onCardClick: null,
  isSelected: false,
};

export default BookCard;
